import { Box } from "@mui/system";
import { useEffect } from "react";
import "./App.css";
import Routes from "./common/router/Routes";
import Main from "./components/common/main";
import Nav from "./components/common/nav";
import { clearUser, setUser } from "./common/features/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { Auth } from "@aws-amplify/auth";
import Modal from "./components/common/modal";
import { Role } from "./common/roles/role";
import {
  fetchPointsOfSalebyId,
  setSubscribed,
} from "./common/features/pointsOfSale/pointsOfSaleSlice";
import {
  selectNotificationsStatus,
  fetchNotifications,
  clearNotifications,
} from "./common/features/notifications/notificationsSlice";
import {
  fetchDistributors,
  selectAllDistributors,
} from "./common/features/distributors/distributorsSlice";

function App() {
  const dispatch = useDispatch();
  // Global selectors
  const { role, pointOfSale } = useSelector((state) => state.auth.user || {});
  const pointsOfSaleStatus = useSelector((state) => state.pointsOfSale.status);
  const distributorStatus = useSelector((state) => state.distributors.status);
  const isSubscribedPdv = useSelector((state) => state.pointsOfSale.subscribed);
  const pdv = useSelector((state) => state.pointsOfSale.pointOfSale || {});
  const distributors = useSelector(selectAllDistributors);
  const notificationsStatus = useSelector(selectNotificationsStatus);

  // Native topic subscription helpers
  const subscribeTopics = async (topic) => {
    console.log("Subscribing to topics:", topic);
    if (window.TopicsWebInterface) {
      window.TopicsWebInterface.subscribeToTopics(JSON.stringify(topic));
    } else if (window.webkit?.messageHandlers?.topics) {
      let message = { command: "subscribeToTopics", topics: topic };
      window.webkit.messageHandlers.topics.postMessage(message);
    } else {
      // No Android or iOS interface found
      console.log("No native APIs found.");
    }

  };
  const unsubscribeTopics = async (topics) => {
    console.log("Unsubscribing from topics:", topics);
    if (window.TopicsWebInterface) {
      window.TopicsWebInterface.unsubscribeFromTopics(JSON.stringify(topics));
    } else if (window.webkit?.messageHandlers?.topics) {
      let message = { command: "unsubscribeFromTopics", topics };
      window.webkit.messageHandlers.topics.postMessage(message);
    } else {
      // No Android or iOS interface found
      console.log("No native APIs found.");
    }

  };

  // Global: fetch PDV
  useEffect(() => {
    if (role === Role.Kiosko && pointsOfSaleStatus === "idle") {
      dispatch(fetchPointsOfSalebyId(pointOfSale));
    }
  }, [pointsOfSaleStatus, role, dispatch, pointOfSale]);

  // Global: fetch distributors
  useEffect(() => {
    if (role === Role.Kiosko && distributorStatus === "idle") {
      dispatch(fetchDistributors(role));
    }
  }, [distributorStatus, role, dispatch]);

  // Global: subscribe/unsubscribe topics
  useEffect(() => {
    if (
      role === Role.Kiosko &&
      pdv.id &&
      !isSubscribedPdv &&
      distributors.length > 0
    ) {

      if (pdv.id_distributor){
        const topic = "distributor" + pdv.id_distributor;
        subscribeTopics([topic]);
      }
      
      const topicPdv = "pdv" + pdv.id;
      subscribeTopics([topicPdv]);

      const unSubscribeDistributorIds = distributors
        .filter((distributor) => distributor.id !== pdv.id_distributor)
        .map((distributor) => "distributor" + distributor.id);
      unsubscribeTopics(unSubscribeDistributorIds);
      dispatch(setSubscribed(true));
    }
  }, [role, pdv, dispatch, isSubscribedPdv, distributors]);

  // Global: notifications fetch/clear
  useEffect(() => {
    if (role === Role.Kiosko && notificationsStatus === "idle") {
      dispatch(fetchNotifications(role));
    }
    const interval = setInterval(() => {
      dispatch(clearNotifications());
    }, 300000);
    return () => clearInterval(interval);
  }, [notificationsStatus, dispatch, role]);

  // Global: user authentication check
  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        let serializedUser = JSON.stringify(user);
        dispatch(setUser(serializedUser));
      })
      .catch((err) => dispatch(clearUser()));
  }, [dispatch]);

  return (
    <Box sx={{ display: "flex" }}>
      <Nav></Nav>
      <Main>
        <Routes />
      </Main>
      <Modal />
    </Box>
  );
}

export default App;
